import React, { useEffect } from 'react';
import { useWidget } from 'components/Widget/useWidget';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import ninjaApi from 'store/redux/apis/ninja.api';
import ChannelChart from 'components/charts/ChannelsChart';

const ChannelStackBar = ({ height }) => {
  const { filters, widget_key, chartConfig } = useWidget();
  const { date_from, date_to } = useWidgetDate(widget_key);
  const [getChannelsProfitAndLossQuery, { data = {}, isLoading }] =
    ninjaApi.useLazyChannelsProfitAndLossQuery();

  useEffect(() => {
    const params = {
      date_from,
      date_to,
      ...filters,
    };

    if (chartConfig?.load_chart) {
      params.group_by = 'date';
    }

    if (params?.date_from) {
      getChannelsProfitAndLossQuery(filters).unwrap();
    }
  }, [filters, chartConfig?.load_chart]);

  return (
    <ChannelChart
      data={data?.data}
      height={height}
      selected_metrics={chartConfig.selected_metrics}
      isLoading={isLoading}
      showXAxis={!chartConfig.showXAxis}
      showYAxis={!chartConfig.showYAxis}
    />
  );
};

export default ChannelStackBar;
